import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext, SttFormSelect } from '../all';

type PaymentForm = {
    id: string;
    caption: string;
};

type Props = {
    caption?: string;
    defVal?: string;
    activePFs?: (string | boolean | undefined | null)[];
    onChange: (event: { name: string | undefined; value: unknown }) => void;
    [key: string]: unknown;
};

/**
 * Seleccionar una forma de pago
 *
 * Las formas de pagos actuales son: CASH, PURSE, BANK, DATAFONO, TPV, FREE, RECEIPT y ''
 *
 * Props:
 *  string name: control name
 *     string defVal: currently selected value
 *     array activePFs: listado de formas de pago a mostrar. Si no se establece aparecerán todas.
 *     function onChange => ({name, value}): value is CASH, PURSE, etc.
 */
export function SttSelectPForm({
    caption,
    defVal,
    activePFs = [''],
    onChange,
    ...rest
}: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [activePaymentForms, setActivePaymentForms] =
        useState<PaymentForm[]>();

    /**
     * Active PF's change
     */
    useEffect(() => {
        if (activePFs && cxt?.constants?.paymentForms) {
            // Changing "" by "LATER"
            const auxPFs = cxt.constants.paymentForms.map((pf: any) =>
                pf.id === '' ? { ...pf, id: 'LATER' } : pf,
            );

            // Only take the input PF's (filter out falsy values first)
            const validPFs = activePFs.filter(
                (pf): pf is string => typeof pf === 'string',
            );
            setActivePaymentForms(
                auxPFs.filter((pf: PaymentForm) =>
                    validPFs
                        .map((pf: string) => (pf === '' ? 'LATER' : pf))
                        .includes(pf.id),
                ),
            );
        }
    }, [activePFs, cxt?.constants]);

    // Render
    return (
        <SttFormSelect
            caption={caption !== undefined ? caption : t('payment.paymentForm')}
            defVal={defVal === '' || defVal === undefined ? 'LATER' : defVal}
            onChange={({ name, value }: any) =>
                onChange({ name, value: value === 'LATER' ? '' : value })
            }
            options={activePaymentForms}
            {...rest}
        />
    );
}
